/**
 * Runtime value for the Algorand Platform
 */
export const _platform = "Algorand";
export function safeBigIntToNumber(b) {
    if (b < BigInt(Number.MIN_SAFE_INTEGER) || b > BigInt(Number.MAX_SAFE_INTEGER)) {
        throw new Error("Integer is unsafe");
    }
    return Number(b);
}
//# sourceMappingURL=types.js.map